import { ref } from 'vue';

// Shared so the changelog can be opened from anywhere - the version badge, the
// navbar update entry or an update notification - while a single dialog
// instance is mounted in `App.vue`.
const open = ref(false);

export const useVersionHistoryDialog = () => {
  const show = () => {
    open.value = true;
  };

  const hide = () => {
    open.value = false;
  };

  return { open, show, hide };
};
